import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

export const advanceTrainingFollowUpEndDateToHourQuota = createAsyncThunk<
  void,
  { trainingFollowUpId: string },
  { extra: Partial<Dependencies> }
>("trainingFollowUps/advanceTrainingFollowUpEndDateToHourQuota", async ({ trainingFollowUpId }, { extra: { adminRepository } }) => {
  return adminRepository!.advanceTrainingFollowUpEndDateToHourQuota(trainingFollowUpId);
});
